<template>
  <div>
    <b-dropdown
      size="lg"
      variant="link"
      toggle-class="text-decoration-none p-2 "
      no-caret
      dropdown
      text="Drop-Down"
    >
      <template #button-content>
        <feather-icon
          class="cursor-pointer"
          icon="MoreVerticalIcon"
          svgClasses="w-4 h-4"
        ></feather-icon>
      </template>
      <b-dropdown-item @click="handleMakeAdmin" cla v-if="canMakeAdmin"
        >Make Admin</b-dropdown-item
      >
      <b-dropdown-item @click="handleRemoveAdmin" v-if="canRemoveAdmin"
        >Remove Admin</b-dropdown-item
      >
      <b-dropdown-item @click="handleRemoveMember" v-if="canRemoveMember"
        >Remove Member</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
    userID: {
      type: String,
      defualt: "",
    },
    currentUserRole: {
      type: String,
      defualt: "member",
    },
  },
  computed: {
    // ...mapState("channel", {
    //   channel: "selectedChannel",
    // }),
    ...mapState("channel", {
      channel: "selectedChannel",
    }),
    isCurrentUserOwner() {
      return this.currentUserRole === "owner";
    },
    isCurrentUserAdmin() {
      return ["owner", "admin"].includes(this.currentUserRole);
    },
    isMember() {
      return !this.isOwner && !this.isAdmin;
    },
    canMakeAdmin() {
      return (
        (this.isCurrentUserOwner && this.isMember) ||
        (this.isCurrentUserAdmin && this.isMember)
      );
    },
    canRemoveAdmin() {
      return this.isCurrentUserOwner && this.isAdmin && !this.isOwner;
    },
    canRemoveMember() {
      return this.isCurrentUserAdmin && this.isMember;
    },
  },
  methods: {
    async handleMakeAdmin() {
      // console.log("you try to make admin");
      // console.log("channle infor ", this.channel);
      const payload = {
        channelID: this.channel._id,
        channelMemberID: this.userID,
        role: "admin",
      };

      let loader = this.$loading();
      try {
        await this.$store.dispatch("channel/updateRole", payload);
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    async handleRemoveAdmin() {
      const payload = {
        channelID: this.channel._id,
        channelMemberID: this.userID,
        role: "member",
      };

      let loader = this.$loading();
      try {
        await this.$store.dispatch("channel/updateRole", payload);
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    async handleRemoveMember() {
      const payload = {
        channelID: this.channel._id,
        UserID: this.userID,
      };

      let loader = this.$loading();
      try {
        await this.$store.dispatch("channel/removeMember", payload);
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
  },
};
</script>
